import { APIHeader } from '../..';

export async function fetchFilesFromCreator(url, pecrId) {
  try {
    const response = await fetch(`${url}api/FetchFiles`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
      }),
    });
    const files = await response.json();
    const filteredFiles = files.filter(file => {
      return file.includes('.');
    });
    return filteredFiles;
  } catch (error) {
    return error;
  }
}

export async function fetchFilesFromOwner(url, pecrId, siteId) {
  try {
    const response = await fetch(`${url}api/FetchFilesFromOwner`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
        siteId: siteId,
        owner: 'Owner',
      }),
    });
    const files = await response.json();
    const filterFilesOnly = files.filter(file => {
      return file.includes('.');
    });
    return filterFilesOnly;
  } catch (error) {
    return error;
  }
}
